module.exports = __webpack_public_path__ + "static/media/email-alt.e8480eaf.png";